// Angular service to handle signup
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { APIRoutes } from '../global-misc/api-routes';
import { CreateAccountModel } from '../global-data-models/create-account.model';

@Injectable({ providedIn: 'root' })
export class SigninService {
  constructor(private http: HttpClient) {}

  async twoFactorRequest(email: string, password: string): Promise<{ token: string }> {
    const response = await firstValueFrom(this.http.post(APIRoutes.TWO_FA_ROUTE, { email, password }));

    if (!response) {
      throw new Error('Nothing returned from 2FA request');
    }

    return response as any;
  }

  async twoFactorCheck(email: string, password: string, code: string): Promise<{ token: string }> {
    const response = await firstValueFrom(this.http.post(APIRoutes.CHECK_TWO_FA_ROUTE, { email, password, code }));

    if (!response) {
      throw new Error('Nothing returned from 2FA request');
    }

    return response as any;
  }
}
